export default __webpack_public_path__ + "static/media/640_dummy2016-personal01-de.c451d83b.png";